<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            Atribuir Perfil
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
							<v-col cols="6">
                <v-text-field
                  v-model="content.nome"
                  label="Nome do Usuário*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
							<v-col cols="6">
                <v-text-field
                  v-model="content.cpf"
                  label="CPF*"
                  v-mask="'###.###.###-##'"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
						<v-row>
							<v-col cols="12">
								<v-autocomplete
									v-model="content.perfis"
									label="Perfil"
									:items="form.lists.perfis"
									:item-text="'nome'"
									:item-value="'id'"
                  multiple
									:rules="[(v) => $required(v)]"
									outlined
									dense
								></v-autocomplete>
							</v-col>
						</v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="'Salvar'"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>
    
  <script>
import { DialogProps } from "~/commons/classes/dialog-props";
import { Organograma } from "~/commons/classes/organograma";
import ManterPerfilService from "@/services/manter-perfil.service";

export default {
  props: new DialogProps(Organograma),
  mixins: [ManterPerfilService],
  data: () => ({
    form: {
      lists: {
        perfis: [],
      },
    },
  }),
	methods: {
		buscarPerfis() {
			this.$buscarPerfis({params: {situacao: true}}).then(({ data }) => (this.form.lists.perfis = data.lista));
		},
		salvar() {
			if (this.$validarFormulario()) {
				this.$swal({
					text: `Deseja confirmar essa operação?`,
					type: "warning",
					showCancelButton: true,
					confirmButtonText: `Confirmar`,
					cancelButtonText: `Cancelar`,
				}).then(() => {
          const perfilIds = this.content.perfis.map(perfil => perfil.id || perfil);
          const body = { usuario: this.content.id, perfil: perfilIds };
					this.$atribuirPerfil(body).then(() => {
						this.$emit("onSave");
						this.$emit("onClose");
						this.$notifySuccess("Operação realizada com sucesso.");
					});
				});
			}
			
		},
	},
	mounted() {
		this.buscarPerfis();
	},
};
</script>
    